import endpoints, { formatEndpoint } from '../endpoints';
import { RestManagerWithoutBaseUrl } from '../RestManager';


class UserProfileApi {

    updateUser(userData) {
        const endpoint = formatEndpoint(endpoints.profile.updateUserProfile);
        return RestManagerWithoutBaseUrl.patch(endpoint, userData);
    }

    acceptEULA() {
        const endpoint = formatEndpoint(endpoints.userProfile.acceptEULA);
        return RestManagerWithoutBaseUrl.post(endpoint);
    }

    getAvailableLanguages() {
        const endpoint = formatEndpoint(endpoints.profile.getAvailableLanguages);
        return RestManagerWithoutBaseUrl.get(endpoint);
    }

    getUserProfile() {
        const endpoint = formatEndpoint(endpoints.profile.getUserProfile);
        return RestManagerWithoutBaseUrl.get(endpoint);
    }
}

export default new UserProfileApi();
